export const complianceDocumentExportColumns = [
	{ label: 'Sr No', key: 'index' },

	{
		label: 'Compliance Name',
		render: (c) => c?.compliancedate?.name || '',
	},

	{
		label: 'Frequency',
		render: (c) => c?.frequency || '',
	},

	{
		label: 'File',
		render: (c) => c?.file || '',
	},

	{
		label: 'Uploaded Date',
		render: (c) => (c?.createdAt ? new Date(c.createdAt).toLocaleDateString('en-US') : ''),
	},
]

export const complianceDueDateExportColumns = [
	{ label: 'Sr No', key: 'index' },

	{
		label: 'Compliance Name',
		render: (c) => c?.compliancedate?.name || '',
	},

	{
		label: 'Compliance Due Date',
		render: (c) => c?.compliancedate?.documentDuedate || '',
	},

	{
		label: 'Filing Date',
		render: (c) => (c?.filingDate ? new Date(c.filingDate).toLocaleDateString('en-US') : ''),
	},
]
